import PropTypes from 'prop-types';
import React from 'react';
import EmptyStates from '../../components/empty-states';
import Page from '../../components/page';
import AppLoaded from '../../components/app-loaded';
import withTranslate from '../../hoc/with-translate';
import withCardBorderWidth from '../../hoc/with-card-border-width';
import styles from './search-page.scss';

const SearchPage = ({ t, borderWidth }) => {
  return (
    <Page>
      <div style={{ marginTop: -borderWidth }}>
        <EmptyStates
          className={styles.emptyStatesContainer}
          title={t('search-page.no-results-title')}
          content={t('search-page.no-results-content')}
        />
      </div>
      <AppLoaded/>
    </Page>
  );
};

SearchPage.propTypes = {
  t: PropTypes.func.isRequired,
  borderWidth: PropTypes.number,
};

export default withTranslate(withCardBorderWidth(SearchPage));



// WEBPACK FOOTER //
// ./app/containers/search-page/search-page.js